/**
 * Class for producting tooltips that sit under the mouse
 */
export default class Tooltip {
  text;
  element;
  player;
  isVisible;

  /**
   * Creates a tooltip with the given contents
   *
   * @param {Player} player
   * @param {string} text
   */
  constructor(player, text) {
    this.player = player;
    this.text = text;

    this.element = document.createElement("div");
    this.element.className = player.stylesheet.classes.tooltip;

    this.element.innerHTML = this.text;
    this.hidden = false;

    if (this.text.length === 0) {
      this.hidden = true;
      return;
    }

    player.container.appendChild(this.element);

    document.addEventListener("mousemove", this.checkOverlapMoveTooltip);
  }

  //overlap prevention. very global. theres probs a better way
  checkOverlapMoveTooltip() {
    let doesOverlap = (el1, el2) => {
      if (el1 === null || el2 === null) return false;
      let rect1 = el1.getBoundingClientRect();
      let rect2 = el2.getBoundingClientRect();

      return !(
        rect1.right < rect2.left ||
        rect1.left > rect2.right ||
        rect1.bottom < rect2.top ||
        rect1.top > rect2.bottom
      );
    };

    let popup = document.querySelector("div[class*='active']");
    let tooltip = document.querySelector("div[class*='visible']");

    if (doesOverlap(popup, tooltip)) {
      let popup_rect = popup.getBoundingClientRect();
      let tooltip_rect = tooltip.getBoundingClientRect();
      tooltip.style.top = popup_rect.y - (37 + 35) + "px";
      tooltip.style.left = popup_rect.right - tooltip_rect.width + "px";
    }
  }

  /**
   * Updates the position of the tooltip based on mouse position
   *
   * @param {MouseEvent} event
   */
  onMouseMove(event) {
    if (!event) {
      return;
    }
    if (event.changedTouches) {
      //Allow for touch
      event = event.changedTouches[0];
    }

    if (Math.abs(event.clientX - window.innerWidth) > 120) {
      //If near the edge of the screen
      this.element.style.left = event.clientX + 5 + "px";
    } else {
      const { width } = this.element.getBoundingClientRect();
      this.element.style.left = event.clientX - width + 5 + "px";
    }
    if (this.player.isMobile) {
      this.element.style.top = event.clientY + 5 - 60 + "px";
    } else {
      this.element.style.top = event.clientY + 5 + "px";
    }
  }

  /**
   * Change the visiblity of the tooltip
   */
  setVisibility(visible) {
    this.isVisible = visible;

    const className = this.player.stylesheet.classes.tooltip;

    this.element.className = `${className} ${visible ? "visible" : ""}`;
  }

  alignToCenter() {
    const { width } = this.element.getBoundingClientRect();
    const widthHalf = window.innerWidth / 2;
    const heightHalf = window.innerHeight / 2;
    this.element.style.top = `${heightHalf + 15}px`;
    this.element.style.left = `${widthHalf - width / 2}px`;
  }

  update(str) {
    this.text = str;
    this.element.innerHTML = str;
  }

  /**
   * Called just before the hotspot is to be removed.
   * Used to cleanup.
   */
  destroy() {
    if (this.hidden) {
      return;
    }
    document.removeEventListener("mousemove", this.checkOverlapMoveTooltip);
    this.player.container.removeChild(this.element);
  }
}
